/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { theme, SVGIcon } from "@nordcloud/gnui";
import { SUCCESS_TEXT } from "~/constants";
import { showSimpleInfo } from "~/services/toast";

type Props = {
  value: string;
};

export function DetailCopyClipboard({ value }: Props) {
  return (
    <CopyToClipboard
      text={value}
      onCopy={() => {
        showSimpleInfo(SUCCESS_TEXT.copied);
      }}
    >
      <SVGIcon
        name="copy"
        size="sm"
        css={{
          cursor: "pointer",
          fill: theme.color.interactive.link,
          minWidth: "0.875rem",
        }}
      />
    </CopyToClipboard>
  );
}
